import merge from 'lodash.merge'
import { Swiper, Navigation, Pagination, Autoplay, Manipulation } from 'swiper'

export default (selector, options = {}) => {
    let dataDefault = {
        spaceBetween: 16,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },

        pagination: {
            type: 'bullets',
            clickable: true,
            el: '.swiper-pagination'
        },

        breakpoints: {
            0: {
                slidesPerView: 1
            },
            576: {
                slidesPerView: 2
            },
            767: {
                slidesPerView: 3
            }
        },

        on: {
            afterInit(s) {
                let bindEvent = (el, ev) => {
                    el.addEventListener('click', () => {
                        $app.runEvent('click', {
                            [s.el.dataset.event]: (s.el.dataset.eventCapt ? s.el.dataset.eventCapt + '.' : '') + ev
                        })
                    })
                }

                try {
                    bindEvent(s.navigation.nextEl, 'вперёд')
                    bindEvent(s.navigation.prevEl, 'назад')
                    bindEvent(s.pagination.el, 'пагинация')
                } catch (e) {

                }
            },

            click: (instance, event) => {
                if (instance.el.dataset.event) {
                    let data = {},
                        parentEventCapt = event.target.closest('[data-event-capt]')

                    data[instance.el.dataset.event] = event.target.dataset.eventCapt
                        || (parentEventCapt ? parentEventCapt.dataset.eventCapt : null)
                        || event.target.textContent.trim()
                        || event.target.classList.toString().trim()

                    $app.runEvent('click', data)
                }
            }
        },

        modules: [Navigation, Pagination, Autoplay, Manipulation]
    }

    return new Swiper(selector, merge(dataDefault, options))
}